// extracted by mini-css-extract-plugin
module.exports = {"rating":"Rating_rating__gmQyg","empty":"Rating_empty__r_a_3","star":"Rating_star__jCJU6","count":"Rating_count__PotB6"};